<template>
  <div class="d-flex justify-space-between">
    <p class="align-center d-flex">
      <span :class="{ 'custom-loader': rotate }">
        <v-icon :color="!disabled ? 'primary' : ''">mdi-sync</v-icon>
      </span>
      <span class="ml-1 text-center">
        <a @click.prevent="!disabled && sendVerificationCodeToPhone()"
          ><span :class="{ 'color-suva-grey': disabled }"
            >I didn't get a code</span
          ></a
        >
      </span>
    </p>
    <p v-if="disabled" class="color-suva-grey">
      Try again in {{ timeleft }} Seconds
    </p>
  </div>
</template>

<script>
export default {
  name: "AuthElementsSMSResend",
  data() {
    return {
      disabled: false,
      resendTimer: null,
      rotate: false,
      valid: true,
      timeleft: 0,
    };
  },
  beforeDestroy() {
    if (this.resendTimer) {
      clearInterval(this.resendTimer);
    }
  },
  mounted() {
    this.setTimeoutAndDisableFor15Seconds();
  },
  methods: {
    sendVerificationCodeToPhone() {
      this.setTimeoutAndDisableFor15Seconds();
      this.$store.commit("auth/SHOW_SMS_RETRY_MESSAGE", false);

      this.$store.dispatch("auth/sendVerificationCodeToPhone", {
        country_code: 1,
        phone_number: this.phone,
      });

      if (!this.resent) {
        return;
      }
      this.resent();
    },
    setTimeoutAndDisableFor15Seconds() {
      this.disabled = true;
      this.rotate = true;
      this.timeleft = 15;
      this.resendTimer = setInterval(() => {
        if (this.timeleft === 13) {
          this.rotate = false;
        }
        if (this.timeleft <= 0) {
          this.disabled = false;
          this.timeleft = 0;
          clearInterval(this.resendTimer);
          this.resendTimer = null;
          return;
        }
        this.timeleft--;
      }, 1000);
    },
  },
  props: { phone: String, resent: Function },
};
</script>
<style scoped>
.custom-loader {
  animation: loader 1s infinite;
}
@keyframes loader {
  from {
    transform: rotate(360deg);
  }
  to {
    transform: rotate(0);
  }
}
</style>
